import React from 'react'
import JobSeekerHeading from '../JobSeekerHeading'
import styles from './ScoresMarking.module.scss'

const ScoresMarking = () => {
  return (
    <div className={styles.main}>
      <div className={`${styles.container} `}>
        <div className={`${styles.inner} px-sm-5 py-3`}>
          <JobSeekerHeading
            title="SCORES AND MARKING"
            subHeading={[
              'Your score relates your performance to an',
              <span> average group.</span>,
              'Your aptitude, ability or intelligence has a relative value to this average result.',
            ]}
          />
          <div className={`${styles.section} d-flex my-5 `}>
            <div className="text-center" style={{ fontSize: '1.1em' }}>
              An <span>‘average’</span> performance is all that is required to
              pass an{' '}
              <a href="https://www.practicereasoningtests.com//practice-aptitude-tests">
                aptitude test
              </a>
              .
              <p>
                Most employers take people’s backgrounds into consideration for
                marking.
              </p>
              <p>
                <b>
                  <em>
                    <span>
                      For example, maths graduates will have an unfair advantage
                      over arts graduates on a{' '}
                      <a href="https://www.practicereasoningtests.com//practice-numerical-test">
                        numerical test
                      </a>
                      .
                    </span>
                  </em>
                </b>
              </p>
            </div>
            <div>
              <img src="./scores.svg" alt="scores" width="100%" height="100%" />
            </div>
          </div>
          <div className={styles.blueBlock}>
            <div className={`${styles.single} d-flex my-2 p-3`}>
              <div>
                <img
                  src="/negative-marketing.svg"
                  alt="negative-marketing"
                  width="100%"
                  height="100%"
                />
              </div>
              <div>
                <h3>NEGATIVE MARKING</h3>
                <p>
                  Many <a>aptitude tests</a> incorporate negative marking. This
                  means that for every answer you give incorrectly, a mark will
                  be deducted from your total (rather than scoring no mark). If
                  this is the case, you will normally be told beforehand.
                </p>
                <p>
                  In any{' '}
                  <a rel="nofollow" href="https://l.linklyhq.com/l/O0fY">
                    test
                  </a>{' '}
                  that does incorporate negative marking, you must not guess
                  answers, even if you are under extreme time pressure, as you
                  will undo your chances of passing.
                </p>
              </div>
            </div>
            <div className={`${styles.single} d-flex my-2 p-3`}>
              <div>
                <img
                  src="/practice-in-advance.svg"
                  alt="practice-in-advance"
                  width="100%"
                  height="100%"
                />
              </div>
              <div>
                <h3>PRACTICE IN ADVANCE</h3>
                <p>
                  Evidence suggests that some practice of similar{' '}
                  <a href="https://www.practicereasoningtests.com//practice-aptitude-tests">
                    aptitude tests
                  </a>{' '}
                  may improve your performance in the real{' '}
                  <a rel="nofollow" href="https://l.linklyhq.com/l/O0fY">
                    tests
                  </a>
                  . Practice exam technique and try to become more familiar with
                  the types of{' '}
                  <a rel="nofollow" href="https://l.linklyhq.com/l/O0fY">
                    test
                  </a>{' '}
                  you may face by completing practice questions.
                </p>
                <p>
                  Even basic word and number puzzles may help you become used to
                  the comprehension and arithmetic aspects of some{' '}
                  <a rel="nofollow" href="https://l.linklyhq.com/l/O0fY">
                    tests
                  </a>
                  .
                </p>
              </div>
            </div>
            <div className={`${styles.single} d-flex my-2 p-3`}>
              <div>
                <img
                  src="/preparation-before.svg"
                  alt="preparation-before"
                  width="100%"
                  height="100%"
                />
              </div>
              <div>
                <h3>PREPARATION BEFORE THE TEST</h3>
                <p>
                  Treat{' '}
                  <a href="https://www.practicereasoningtests.com//practice-aptitude-tests">
                    aptitude tests
                  </a>{' '}
                  like an interview: get a good night’s sleep, plan your journey
                  to the{' '}
                  <a rel="nofollow" href="https://l.linklyhq.com/l/O0fY">
                    test
                  </a>{' '}
                  site, and arrive on time and appropriately dressed. Listen to
                  the instructions you are given and follow them precisely.
                </p>
              </div>
            </div>
            <div className={styles.block}>
              Before the actual{' '}
              <a href="https://www.practicereasoningtests.com//practice-aptitude-tests">
                aptitude test
              </a>
              , you will almost certainly be given practice examples to try.
              Make sure you ask questions if anything is unclear at this stage.
              <p>
                You will normally be given some paper on which to make rough
                workings. Often you can be asked to hand these in with the{' '}
                <a rel="nofollow" href="https://l.linklyhq.com/l/O0fY">
                  test
                </a>
                , but typically they do not form part of the assessment
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default ScoresMarking
